import { VirtualLocation as VirtualLocationProps } from "common/event/event.types";
import * as React from "react";
import VirtualLocation from "../EditableSlotItem/VirtualLocation";
import { Modal } from "@ic-anywhere/ic-components";

interface Props {
  onClose: () => void;
  virtualLocation: VirtualLocationProps;
}

export const VirtualLocationInfoModal: React.FC<Props> = ({ onClose, virtualLocation }) => {
  return (
    <Modal
      show={true}
      isConfirmValid={false}
      backdropClose={true}
      size="md"
      title="Virtual location information"
      onClose={onClose}
    >
      <VirtualLocation {...virtualLocation} className="d-block mt-2 text-primary" />
    </Modal>
  );
};
